import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import './editPlacementVisitModal.scss'
import { TransitionProps } from '@mui/material/transitions';
import { useEffect, useState } from 'react';
import { Card, Chip, DialogActions, Divider, MenuItem, TextField, } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { useNavigate } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CardContent from '@mui/material/CardContent';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import map from "../../../../../assets/map.jpg"
import { useAppSelector, useAppDispatch } from '../../../../../store/hooks/hooks';
import AdminApi from '../../../../../store/services/admin';
import { StudentActions, getEvents } from '../../../../../store/StudentAction';
import { createNotifictions } from '../../../../../utils/helperFunction';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import Avatar from '../../../../../utils/Avatar/Avatar';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const EditPlacementVisitModal: React.FC<{ event: any,editEventComplete:any }> = ({ event,editEventComplete }) => {
    const [open, setOpen] = React.useState(false)
    const [eventName, setEventName] = useState(event.details.title)
    const [googleMapUrl, setGoogleMapUrl] = useState(event.details.meetingUrl)
    const userDetails = useAppSelector((state: any) => state.user.user)
    const [origin, setOrigin] = React.useState("University Rd, Leicester LE1 7RH");
    const [destination, setDestination] = React.useState(event.details.destination);
    const [participants, setParticipants] = useState(event.details.participants)
    const [scheduleDate, setScheduleDate] = React.useState<Dayjs | null>(
        dayjs(new Date(event.details.scheduleDate)),
    );
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setIsLoading(false)
        setOpen(false);
    };
    const assignValue = () => {
        setDestination(event.details.destination)
        setScheduleDate(dayjs(new Date(event.details.scheduleDate)))
        setGoogleMapUrl(event.details.meetingUrl)
        setEventName(event.details.title)
        setParticipants(event.details.participants)
    }
    const reset = () => {
        setScheduleDate(dayjs(new Date()))
        setGoogleMapUrl("")
        setEventName("")
    }
    const handleSubmit = async (e: any) => {
        setIsLoading(true)
        e.preventDefault()
        const editEvent = Object.keys(event) && event as any
        let body = {
            EventType: "PV",
            userId: userDetails.result.Id,
            id: editEvent._id,
            details: {
                dateApplied: new Date(),
                scheduleDate: scheduleDate,
                destination: destination,
                origin: origin,
                meetingUrl: googleMapUrl,
                title: "Placement Visit",
                participants: [...participants],
                rejectedParticipants: [],
                acceptedParticipants: [...event.details.acceptedParticipants]
            }
        }
        AdminApi.newEventRequest(body).then(async res => {
            dispatch(StudentActions.setMessage("Visit Edited"))
            participants.forEach((elm: any) => {
                if (elm.placement.CompanyName !== "University Rd, Leicester") {
                    createNotifictions({
                        target: elm.user.Student_ID,
                        message: `${eventName} visit was scheduled by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                        type: "PV",
                        eventId: res.data._id
                    })
                }

            })
            editEventComplete()
            await dispatch(getEvents("all"))
            setIsLoading(false)
        }).catch((e) => {
            if (e.response.status === 403) {
                navigate('/login')
            }
            setIsLoading(false)
            reset()
            dispatch(StudentActions.setMessage("Request Generation Failed.Try again."))
        })
    }
    useEffect(() => {
        reset()
        handleClose()
    }, [isLoading])
    useEffect(() => {
        assignValue()
    },[event])

    useEffect(() => {
        let destinationPlacement = participants[participants.length - 1]
        setDestination(`${destinationPlacement.placement.CompanyName} ${destinationPlacement.placement.RegAddressPostCode}`)
    }, [participants])
    return (
        <div>
            <MenuItem onClick={() => {
                if (event.details.acceptedParticipants.length > 1) {
                    dispatch(StudentActions.setMessage(`${event.details.title} editing is not possible`))
                }
                else {
                    handleClickOpen()
                }
            }} disableRipple>
                <ModeEditRoundedIcon fontSize='small' className='m-2' />
                Edit
            </MenuItem>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Schedule Placement Visit</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className='flex flex-column'>
                                <div className='flex justify-content-between m-2'>
                                    <div className='mx-2 w-100'>
                                        <label className='required'>Origin :</label>
                                        <input value={origin} disabled onChange={(e) => {
                                            setOrigin('University Rd, Leicester LE1 7RH')
                                        }}></input>
                                    </div>
                                    <div className='w-100'>
                                        <label className='required'>Destination :</label>
                                        <input value={destination} disabled onChange={(e) => {
                                        }}></input>
                                    </div>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label>Route Path:</label>
                                    <div className='m-1 flex routeScrollContainer flex-row'>
                                        {
                                            participants && participants.map((placementDetails: any, index: any) => {
                                                return (
                                                    <div key={index} className="flex">
                                                        <Card className={index === participants.length - 1 ? ' destinationContainer routeCard m-2 ' : index === 0 ? 'originContainer routeCard m-2' : 'routeCard m-2'}>
                                                            <CardContent className='flex align-items-center p-2'>
                                                                <div className='routeIconContainer align-items-center flex justify-content-center m-2 p-2'>
                                                                    <img src={map} style={{ height: "80px", borderRadius: "4px" }}></img>
                                                                </div>
                                                                <div className='m-1'>
                                                                    <div className='flex p-1'>
                                                                        <PushPinRoundedIcon className='gray-color m-0' fontSize='small'></PushPinRoundedIcon>
                                                                        <p className='routeCardText m-0 mx-1'>{placementDetails.placement.CompanyName}</p>
                                                                    </div>
                                                                    <div className='flex p-1'>
                                                                        <FmdGoodRoundedIcon className='gray-color m-0' fontSize='small'></FmdGoodRoundedIcon>
                                                                        <p className='routeCardText m-0 mx-1'>{placementDetails.placement.RegAddressPostCode}</p>
                                                                    </div>
                                                                    <div className='flex p-1'>
                                                                        <Avatar name={`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}></Avatar>
                                                                        <p className='routeCardText m-0 mx-1'>{`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}</p>
                                                                    </div>
                                                                    <div className='flex justify-content-start p-1'>
                                                                        <Chip
                                                                            label={event.details.acceptedParticipants.includes(placementDetails.user.Id ? placementDetails.user.Id
                                                                                : placementDetails.user.Student_ID) ? "Accepted" : event.details.rejectedParticipants.includes(placementDetails.user.Id ? placementDetails.user.Id
                                                                                    : placementDetails.user.Student_ID) ? "Declined" : "Pending"}
                                                                            className="chip font-weight-700"
                                                                        />
                                                                        {
                                                                            (index === participants.length - 1 || index === 0) ? <></> : <IconButton aria-label="delete" size="small" onClick={() => {
                                                                                setParticipants([...participants.filter((elm : any) => {
                                                                                    return placementDetails.user.Student_ID !== elm.user.Student_ID
                                                                                })])
                                                                            }}>
                                                                                <DeleteIcon fontSize="inherit" />
                                                                            </IconButton> 
                                                                            
                                                                        }
                                                                        
                                                                    </div>
                                                                </div>
                                                            </CardContent>
                                                        </Card>
                                                        {
                                                            index !== participants.length - 1 && <div className='align-items-center flex justify-content-center dividerContainer'>
                                                                <Divider className='dividerWidth' />
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <div className='flex justify-content-between'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>Schedule Date:</label>
                                            <DatePicker
                                                value={scheduleDate}
                                                minDate={dayjs(new Date())}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setScheduleDate(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Google Map URL:</label>
                                    <input value={googleMapUrl} disabled onChange={(e) => {
                                        setGoogleMapUrl(e.target.value)
                                    }}></input>
                                </div>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        onClick={handleSubmit}
                        startIcon={<AddHomeRoundedIcon />}
                        variant="contained"
                        autoFocus
                    >
                        Schedule Visit
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default EditPlacementVisitModal;